import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { Globe, MapPin } from "lucide-react";
import { api } from "@/lib/api";

const SOC = [["instagram", "Instagram"], ["x", "X"], ["youtube", "YouTube"], ["tiktok", "TikTok"]];

export default function OrgPublic({ kind }) {
  const { slug } = useParams();
  const [o, setO] = useState(undefined);
  useEffect(() => { api.get(`/public/organizations/${slug}`).then(({ data }) => setO(data)).catch(() => setO(null)); }, [slug]);
  if (o === undefined) return <div className="h-[60vh]" />;
  if (o === null || !o.types.includes(kind)) return <div className="mx-auto max-w-3xl px-5 py-24" data-testid="org-not-found"><h1 className="font-display text-4xl font-extrabold uppercase">Page introuvable</h1><Link to="/" className="p-btn mt-6">Accueil</Link></div>;
  const color = o.branding?.primary;
  return (
    <div className="mx-auto max-w-4xl px-5 py-16" data-testid="org-public">
      <div className="h-2 w-24" style={{ background: color || "var(--p-accent)" }} />
      <p className="p-eyebrow mt-6">{kind === "COMMUNITY" ? "Community" : "Partenaire"}</p>
      <h1 className="mt-2 font-display text-5xl font-extrabold uppercase sm:text-6xl" data-testid="org-name">{o.name}</h1>
      <p className="mt-3 flex items-center gap-1.5 text-sm p-t3"><MapPin size={14} /> {[o.city, o.region, o.country === "FR" ? "France" : "Canada"].filter(Boolean).join(", ")}</p>
      {o.description && <p className="mt-6 whitespace-pre-line text-base p-t2">{o.description}</p>}
      <div className="mt-6 flex flex-wrap gap-2">
        {o.website && <a href={o.website} target="_blank" rel="noopener noreferrer" className="p-btn-ghost text-sm"><Globe size={14} /> Site web</a>}
        {SOC.filter(([k]) => o.social_links?.[k]).map(([k, l]) => <a key={k} href={o.social_links[k]} target="_blank" rel="noopener noreferrer" className="p-btn-ghost text-sm">{l}</a>)}
      </div>
      {kind === "COMMUNITY" && <p className="mt-12 text-xs p-t3">Powered by Ma Petite Ligue</p>}
    </div>
  );
}
